/** @format */

import axios from "axios";
import { axiosCalls, baseURL, createRequestHeaders } from "../../config/AxiosCall";
import { PersonalDetailsDto } from "../applicant/Models";
import {
  addDeclineReasonDto,
  AssessDto,
  CreateDocumentDto,
  MarkAsRead,
  SetApplicationDatesDto,
  UpdateApplicationStatusDto,
} from "./models";

const url = "Applicant";

export async function fetchAllApplicants(year: number) {
  return axiosCalls.get(`${url}/all-applicants?year=${year}`);
}

export async function setApplicationDates(payload: SetApplicationDatesDto) {
  return axiosCalls.post(payload, `${url}/set-application-dates`);
}

export async function updateHomeBannerImage(payload: {
  homeBannerImageUrl: string | null;
}) {
  return axiosCalls.put(payload, `${url}/update-home-banner-image`);
}

export async function getApplicationDates() {
  return axiosCalls.get(`${url}/get-application-dates`);
}

export async function getAssessmentAudits() {
  return axiosCalls.get(`Assessments/get-assessment-audits`);
}

export async function setApplicationAssessment(payload: AssessDto) {
  return axiosCalls.post(payload, `Assessments/set-application-assessment`);
}

export async function ExportToExcel(payload: string | number, year: number) {
  // Handle special cases where we want to send string values
  let stageValue: string | number = payload;
  
  // If payload is a number, check for special cases
  if (typeof payload === 'number') {
    if (payload === 200) { // Assessed
      stageValue = payload; // Send as number 200
    } else if (payload === 201) { // NotAssessed
      stageValue = payload; // Send as number 201
    } else if (payload === 12) { // ApplicationFullyAssessedAndIsPendingUniversitySelection
      stageValue = payload; // Send as number 12
    } else if (payload === 2025) { // Legacy Assessed value
      stageValue = 200; // Map to the correct Assessed value
    }
  }
  
  console.log('Exporting with stage value:', stageValue, 'and year:', year);
  
  return axios({
    method: 'GET',
    url: `${baseURL}ApplicationManagement/export-to-excel?stage=${stageValue}&year=${year}`,
    responseType: 'blob',
    headers: {
      'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      'Content-Type': 'application/json',
    },
  });
}

export async function ExportApplications(payload: number, year: number) {
  return axios({
    method: 'GET',
    url: `${baseURL}ApplicationManagement/export-to-excel?stage=${payload}&year=${year}`,
    responseType: 'blob',
    headers: {
      'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      'Content-Type': 'application/json',
    },
  });
}

export async function UpdateApplicationStatus(
  payload: UpdateApplicationStatusDto
) {
  return axiosCalls.patch(
    payload,
    `ApplicationManagement/update-application-status`
  );
}

export async function addDeclineReason(payload: addDeclineReasonDto) {
  return axiosCalls.post(payload, `ApplicationManagement/add-decline-reason`);
}

export async function EditDeclineReason(payload: addDeclineReasonDto) {
  return axiosCalls.put(payload, `ApplicationManagement/update-decline-reason`);
}

export async function AllDeclineReasons() {
  return axiosCalls.get(`ApplicationManagement/get-all-decline-reasons`);
}

export async function UpdatePersonalDetails(payload: PersonalDetailsDto) {
  return axiosCalls.put(payload, `Accounts/update-personal-details`);
}

export async function DeleteDeclineReason(declineReasonId: number) {
  return axiosCalls.delete(
    `ApplicationManagement/delete-decline-reasons?id=${declineReasonId}`
  );
}

export async function GetDocumentsForApplicant(applicationId: number) {
  return axiosCalls.get(
    `ApplicationManagement/get-documents-for-applicant?applicationId=${applicationId}`
  );
}

export async function CreateDocumentAPI(payload: CreateDocumentDto) {
  return axiosCalls.post(
    payload,
    `ApplicationManagement/create-document-for-appliant`
  );
}

export async function fetchApplicationYears() {
  return axiosCalls.get(`Applicant/application-years`);
}

export async function fetchPublicDashboard(year: number, key: string) {
  const { data } = await axios.get(`${baseURL}public-reporting/dashboard`, {
    params: { year, key },
  });
  return data;
}

export async function fetchDashboard(year: number) {
  return axiosCalls.get(`Dashboard/get-dashboard?year=${year}`);
}

export async function fetchReturningApplicants(year: number) {
  return axiosCalls.get(`Dashboard/get-returning-applicants?year=${year}`);
}

export async function exportReturningApplicantsExcel(year: number) {
  return axios({
    method: "GET",
    url: `${baseURL}Dashboard/export-returning-applicants-excel?year=${year}`,
    responseType: "blob",
    headers: createRequestHeaders({
      Accept:
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/octet-stream;q=0.9, */*;q=0.8",
    }),
    validateStatus: () => true,
  });
}

export async function fetchNotifications() {
  return axiosCalls.get(`Dashboard/get-all-notification`);
}

export async function markNotificationAsRead(payload: MarkAsRead) {
  return axiosCalls.put(payload, `Dashboard/mark-as-read`);
}
